import { render, staticRenderFns } from "./back-button.vue?vue&type=template&id=c0d9c342&scoped=true"
import script from "./back-button.vue?vue&type=script&lang=js"
export * from "./back-button.vue?vue&type=script&lang=js"
import style0 from "./back-button.vue?vue&type=style&index=0&id=c0d9c342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d9c342",
  null
  
)

export default component.exports